/**
 * TV Offer - Featured Product Bundle section (v2)
 * Separate copy of featured-product-bundle.js used ONLY by the "F.P. Bundle TV Offer 2" section.
 * Handles: gallery (static thumbnails OR per-tier image switching), tier
 * selection, live summed price, multi-line-item add-to-cart via Ajax Cart
 * API, and a buy-now flow that adds items then redirects to checkout.
 *
 * Differences vs. the original featured-product-bundle.js:
 *   1. Global is window.TvOfferFeaturedProductBundle (no clash with the original script).
 *   2. Description "Show more" expands INLINE right after the "..." and a
 *      separate "Show less" button sits at the end of the revealed text.
 *   3. Static gallery mode: a tier's "Image 1" (data-main-src on the tier) replaces
 *      the FIRST gallery image + first thumbnail when that tier is selected.
 *      The rest of the gallery stays the same.
 */
(function () {
  window.TvOfferFeaturedProductBundle = {
    init: function (rootId) {
      var root = document.getElementById(rootId);
      if (!root || root.dataset.fpbInitialized) return;
      root.dataset.fpbInitialized = 'true';

      var mainImgs = root.querySelectorAll('[data-fpb-main-img]');
      var thumbs = root.querySelectorAll('[data-fpb-thumb]');
      var tiers = root.querySelectorAll('[data-fpb-tier]');
      var radios = root.querySelectorAll('[data-fpb-tier-radio]');
      var livePrice = root.querySelector('[data-fpb-live-price]');
      var hiddenInputsWrap = root.querySelector('[data-fpb-hidden-inputs]');
      var form = root.querySelector('[data-fpb-form]');
      var addBtn = root.querySelector('[data-fpb-add-btn]');
      var btnText = root.querySelector('[data-fpb-btn-text]');
      var buyNowBtn = root.querySelector('[data-fpb-buy-now]');
      var statusEl = root.querySelector('[data-fpb-status]');

      // ---- Description: inline "Show more" / "Show less" ----
      var descMore = root.querySelector('[data-fpb-desc-more]');
      var descLess = root.querySelector('[data-fpb-desc-less]');
      var descHiddenEls = root.querySelectorAll('[data-fpb-desc-hidden]');
      if (descMore && descLess && descHiddenEls.length) {
        descMore.addEventListener('click', function () {
          descHiddenEls.forEach(function (el) { el.removeAttribute('hidden'); });
          descMore.setAttribute('hidden', '');
          descLess.focus();
        });
        descLess.addEventListener('click', function () {
          descHiddenEls.forEach(function (el) { el.setAttribute('hidden', ''); });
          descMore.removeAttribute('hidden');
          descMore.focus();
        });
      }

      var usesPerTierGallery = false;
      mainImgs.forEach(function (img) {
        if (img.hasAttribute('data-tier-index')) usesPerTierGallery = true;
      });

      var currentComponents = [];

      // Show the main image with the given data-index and mark its thumbnail active
      function showGalleryIndex(index) {
        index = String(index);
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-index') === index);
        });
        mainImgs.forEach(function (img) {
          if (img.getAttribute('data-index') === index) {
            img.style.display = '';
            img.classList.add('is-active');
          } else {
            img.style.display = 'none';
            img.classList.remove('is-active');
          }
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showGalleryIndex(thumb.getAttribute('data-index'));
        });
      });

      // Static gallery mode: swap the FIRST gallery image (main + thumbnail)
      // for the selected tier's Image 1, then show it.
      function applyTierMainImage(tierEl) {
        if (usesPerTierGallery) return;
        var src = tierEl.getAttribute('data-main-src');
        if (!src) return; // this tier has no Image 1: leave the gallery alone

        var main = null;
        mainImgs.forEach(function (img) {
          if (img.getAttribute('data-index') === '0') main = img;
        });
        var thumb = null;
        thumbs.forEach(function (t) {
          if (t.getAttribute('data-index') === '0') thumb = t;
        });

        if (main) {
          main.removeAttribute('loading');
          main.removeAttribute('srcset');
          main.src = src;
          var srcset = tierEl.getAttribute('data-main-srcset');
          if (srcset) main.srcset = srcset;
        }
        if (thumb) {
          var thumbImg = thumb.querySelector('img');
          var thumbSrc = tierEl.getAttribute('data-main-thumb');
          if (thumbImg && thumbSrc) thumbImg.src = thumbSrc;
        }
        showGalleryIndex(0);
      }

      function showTierGallery(tierIndex) {
        if (!usesPerTierGallery) return;
        var shown = false;
        mainImgs.forEach(function (img) {
          var imgTierIndex = img.getAttribute('data-tier-index');
          var imgIndex = img.getAttribute('data-index');
          if (imgTierIndex === String(tierIndex)) {
            if (!shown && imgIndex === '0') {
              img.style.display = '';
              img.classList.add('is-active');
              shown = true;
            } else {
              img.style.display = 'none';
              img.classList.remove('is-active');
            }
          } else {
            img.style.display = 'none';
            img.classList.remove('is-active');
          }
        });
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme_money_format) {
          return window.Shopify.formatMoney(cents, window.theme_money_format);
        }
        return '$' + (cents / 100).toFixed(2);
      }

      function rebuildHiddenInputs(components) {
        if (!hiddenInputsWrap) return;
        hiddenInputsWrap.innerHTML = '';
        components.forEach(function (comp, i) {
          var idInput = document.createElement('input');
          idInput.type = 'hidden';
          idInput.name = 'items[' + i + '][id]';
          idInput.value = comp.id;
          hiddenInputsWrap.appendChild(idInput);

          var qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'items[' + i + '][quantity]';
          qtyInput.value = comp.quantity;
          hiddenInputsWrap.appendChild(qtyInput);
        });
      }

      function selectTier(tierEl) {
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tierEl.classList.add('is-selected');

        var tierIndex = tierEl.getAttribute('data-tier-index');
        var price = tierEl.getAttribute('data-price');
        var componentsRaw = tierEl.getAttribute('data-components');

        try {
          currentComponents = JSON.parse(componentsRaw || '[]');
        } catch (e) {
          currentComponents = [];
        }

        rebuildHiddenInputs(currentComponents);

        if (livePrice && price) {
          livePrice.textContent = formatMoney(parseInt(price, 10));
        }

        showTierGallery(tierIndex);
        applyTierMainImage(tierEl);

        var soldOut = tierEl.getAttribute('data-sold-out') === 'true';
        var noComponents = currentComponents.length === 0;

        if (addBtn) addBtn.disabled = soldOut || noComponents;
        if (buyNowBtn) buyNowBtn.disabled = soldOut || noComponents;
        if (btnText) {
          if (!btnText.dataset.defaultLabel) btnText.dataset.defaultLabel = btnText.textContent;
          btnText.textContent = soldOut ? 'Sold out' : btnText.dataset.defaultLabel;
        }

        clearStatus();
      }

      tiers.forEach(function (tierEl) {
        var radio = tierEl.querySelector('[data-fpb-tier-radio]');
        tierEl.addEventListener('click', function () {
          if (tierEl.getAttribute('data-sold-out') === 'true') return;
          if (radio) radio.checked = true;
          selectTier(tierEl);
        });
      });

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          var tierEl = radio.closest('[data-fpb-tier]');
          if (tierEl) selectTier(tierEl);
        });
      });

      var initialTier = root.querySelector('[data-fpb-tier-radio]:checked');
      if (initialTier) {
        var initialTierEl = initialTier.closest('[data-fpb-tier]');
        if (initialTierEl) selectTier(initialTierEl);
      } else if (tiers.length) {
        selectTier(tiers[0]);
      }

      function setStatus(message, type) {
        if (!statusEl) return;
        statusEl.textContent = message;
        statusEl.classList.remove('is-error', 'is-success');
        if (type) statusEl.classList.add(type);
      }
      function clearStatus() {
        if (!statusEl) return;
        statusEl.textContent = '';
        statusEl.classList.remove('is-error', 'is-success');
      }

      function addCurrentComponentsToCart() {
        if (!currentComponents.length) {
          return Promise.reject(new Error('Please select a kit option.'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: currentComponents })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Could not add items to cart.');
            });
          }
          return res.json();
        });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn && addBtn.disabled) return;

          if (addBtn) addBtn.disabled = true;
          var originalText = btnText ? btnText.textContent : '';
          if (btnText) btnText.textContent = 'Adding...';

          addCurrentComponentsToCart()
            .then(function () {
              setStatus('Added to cart.', 'is-success');
              document.dispatchEvent(new CustomEvent('cart:updated'));
              document.dispatchEvent(new CustomEvent('fpb:added-to-cart', { detail: { components: currentComponents } }));
            })
            .catch(function (err) {
              setStatus(err.message || 'Something went wrong. Please try again.', 'is-error');
            })
            .finally(function () {
              if (addBtn) addBtn.disabled = false;
              if (btnText) btnText.textContent = originalText;
            });
        });
      }

      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function () {
          if (buyNowBtn.disabled) return;
          buyNowBtn.disabled = true;
          var originalText = buyNowBtn.textContent;
          buyNowBtn.textContent = 'Redirecting...';

          addCurrentComponentsToCart()
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function (err) {
              setStatus(err.message || 'Something went wrong. Please try again.', 'is-error');
              buyNowBtn.disabled = false;
              buyNowBtn.textContent = originalText;
            });
        });
      }
    }
  };
})();
